<template>
  <a
    v-if="href"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    class="m-reset-link"
  >
    <ListItem>
      <template #media>
        <BaseIcon :icon="icon" />
      </template>
      <h4 class="m-font-bold m-font-size-300">{{ label }}</h4>
    </ListItem>
  </a>
  <RouterLink
    v-else
    :to="to"
    class="m-reset-link"
  >
    <ListItem>
      <template #media>
        <BaseIcon :icon="icon" />
      </template>
      <h4 class="m-font-bold m-font-size-300">{{ label }}</h4>
    </ListItem>

  </RouterLink>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';
import ListItem from '@/components/ListItem.vue';

defineProps({
  label: {
    type: String,
    default: '',
  },
  to: {
    type: Object,
    default: null,
  },
  href: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
});
</script>
